import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps } from "@client/controls/Form/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState, Status } from "@client/types";
import Component, { type ActionProps, type MapProps } from "../Button/component";
import { resetPassword } from "../actions";
import { localStateSelector } from "../selectors";
import { type LoginForm } from "../types";

type Props = RootContainerProps &
  FormButtonProps & {
    isLogin: boolean;
  };
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      captionKey: "resetPassword",
      isDisabled: localState.status === Status.Saving
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: LoginForm.View.ResetPasswordFormData) => dispatch(resetPassword(props, data))
});

const ResetPasswordButton = connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);

export default ResetPasswordButton;
